export default "__VITE_ASSET__5xX4Jrzl__"